import { TTokenRedemptionOptionPrize } from '@daymade/api-contracts';
import { ASSET_PREFIX } from 'utils/constants';
import ImageOverlay from '../shared/image-overlay/ImageOverlay';
import styles from './PrizeRedemptionCard.module.css';

interface IPrizeCard {
  prize: TTokenRedemptionOptionPrize;
  onClick: () => void;
}

const PrizeRedemptionCard = ({ prize, onClick }: IPrizeCard) => {
  return (
    <div onClick={() => onClick()} className={styles.card}>
      <img
        className={styles.snowflake}
        src={`${ASSET_PREFIX}/images/token-town/prizes/snowflake.svg`}
        alt="Snowflake icon"
      />
      <div className={`${styles.imageWrapper}`}>
        <img
          className={styles.image}
          src={prize.imageLocations.main}
          alt={prize.title}
        />
        <ImageOverlay />
      </div>
      <div className={styles.textContainer}>
        <p className={styles.title}>{prize.title}</p>
        <p className={styles.subheading}>{prize.subheading}</p>
      </div>
    </div>
  );
};

export default PrizeRedemptionCard;
